// Sanitize html

import DOMPurify from 'dompurify';

export function sanitize(str, options) {
  options = options || { ALLOWED_TAGS: [] };
  return DOMPurify.sanitize(str, options);
}
